import groupBy from "lodash/groupBy";
import keyBy from "lodash/keyBy";
import orderBy from "lodash/orderBy";
import * as types from "../actions/actionTypes";
import intialState from "./initialState";

import { IAvailability } from "../../types/availabilities/Availabilities";
import { IIntervalTree } from "../../util/IntervalTree";
import { IAvailabilityState } from "./state";

const prepareAvailabilities = (
  state: IAvailabilityState,
  availabilities: IAvailability[],
) => {
  const start = new Date();
  const newActivities = keyBy(
    availabilities.filter((a) => !a.archived),
    "_id",
  );
  const archivedActivities = keyBy(
    availabilities.filter((a) => a.archived),
    "_id",
  );

  const newMap = { ...state.map, ...newActivities, ...archivedActivities };
  const persons = { ...state.byPerson };
  const tree: { [id: string]: IIntervalTree } = { ...state.tree };

  const personsToUpdate: { [id: string]: IAvailability[] } = groupBy(
    availabilities,
    "person",
  );

  for (const person in personsToUpdate) {
    const existingAvails = state.byPerson[person] || [];
    const totalAvailsSet = new Set([
      ...existingAvails,
      ...personsToUpdate[person].map((a) => a._id),
    ]);
    persons[person] = orderBy(
      Array.from(totalAvailsSet),
      (a) => newMap[a].start,
    );

    // insert intervals
    // tree[person] = availabilities
    //     .map(av => ({ identifier: av._id, low: av.start.valueOf(), high: av.finish.valueOf() }))
    //     .reduce((tr, int) => IntervalTree.insert_node(tr, int), IntervalTree.empty())
  }

  return {
    map: newMap,
    byPerson: persons,
    tree,
  };
};

const handles = {
  // [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: IAvailabilityState, { availabilities }) => prepareAvailabilities(state, availabilities),
  // [types.SHIFT_ROSTER_GAME_FULFILLED]: (state: IAvailabilityState, { availabilities }) => prepareAvailabilities(state, availabilities),
  [types.AVAILABILITIES_GET_MY_FULFILLED]: (
    state: IAvailabilityState,
    availabilities,
  ) => prepareAvailabilities(state, availabilities),
  [types.AVAILABILITIES_CREATE_FULFILLED]: (
    state: IAvailabilityState,
    availability,
  ) => prepareAvailabilities(state, [availability]),
  [types.AVAILABILITIES_DELETE_FULFILLED]: (
    state: IAvailabilityState,
    availability,
  ) => prepareAvailabilities(state, [availability]),
  [types.AVAILABILITIES_GET_FULFILLED]: (
    state: IAvailabilityState,
    { person, availabilities },
  ) => prepareAvailabilities(state, availabilities),
};

export default function availabilitiesReducer(
  state: IAvailabilityState = intialState.availabilities,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
